import React from "react"
import { Box, Typography } from "@mui/material"

import { REPORT_STATUS } from "@constants"
import ReportListTableReadyBlock from "./ReadyBlock"
import ReportListTableRunningBlock from "./RunningBlock"
import ReportListTableStoppedBlock from "./StoppedBlock"
import { reportListCellData } from "Pages/ReportsAlerts/Reports/@signals"

export default function dateColumn(isExtras) {

	return [{
		name: 'statusLastExecution', label: 'Status',
		options: {
			display: 'excluded',
		}
	}, {
		name: "timestampLastExecutionUser", label: "Date",
		options: {
			filter: false,
			setCellHeaderProps: () => ({ sx: { minWidth: 100 } }),
			customBodyRowRenderLite: (value, rowData) => {
				const statusLastExecution = rowData.statusLastExecution
				const isFinished = reportListCellData.value[rowData?.idLastExecution]?.ExecutionGlobalStatusCompleted
				const timestamp = reportListCellData.value[rowData?.idLastExecution]?.timestampStartExecutionUser || value
				return (
					<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: "90px" }}>
						{!timestamp &&
							<Typography variant="caption">
								Not executed
							</Typography>}
						{(statusLastExecution === REPORT_STATUS.READY || isFinished) &&
							<ReportListTableReadyBlock
								date={timestamp}
								reportExecutionID={rowData.idLastExecution}
								officeID={rowData.idOfficePickup[0]}
								hasCompetitionSites={rowData.hasCompetitionSites}
								hasDirectSites={rowData.hasDirectSites}
								pickUp={rowData.pickUp}
								noResults={rowData.allExecutionsNoResults}
								hasExport={rowData.export}
								hasGenerate={rowData.generate}
							/>}
						{(statusLastExecution === REPORT_STATUS.RUNNING && !isFinished) &&
							<ReportListTableRunningBlock rowData={rowData} isExtras={isExtras}/>}
						{(statusLastExecution === REPORT_STATUS.STOPPED && !isFinished) &&
							<ReportListTableStoppedBlock date={value}/>}
					</Box>
				)
			}
		}
	}]
}
